var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { class: { "is-safari": _vm.isSafari } },
    [
      _vm._t("header"),
      _c(
        "transition",
        { attrs: { name: "fast-fade", mode: "out-in" } },
        [
          _vm.initialized
            ? _c(
                "div",
                {
                  key: "main",
                  style: {
                    maxHeight: "100%",
                    height: "100%",
                    position: "relative",
                  },
                },
                [
                  _vm._t("more"),
                  _c(
                    "app-browse-actions",
                    { staticClass: "actions", attrs: { state: _vm.state } },
                    [
                      _vm._t("top"),
                      _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
                      _vm._t("browse-action-buttons", null, {
                        slot: "browse-action-buttons",
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "browse-content-row" },
                    [
                      _vm.state.inlineIframeUrl &&
                      _vm.state.inlineIframeButton &&
                      _vm.state.inlineIframeButton.IframePosition === "left"
                        ? _c("app-browse-inline-iframe", {
                            attrs: { state: _vm.state },
                          })
                        : _vm._e(),
                      _vm.state.sidebarOpen &&
                      !_vm.$wf.isSmDown &&
                      _vm.state.sidebar.Position === "left"
                        ? _c("app-browse-sidebar", {
                            attrs: { state: _vm.state },
                          })
                        : _vm._e(),
                      _c("app-browse-table", {
                        style: { flex: 1, minWidth: 0 },
                        attrs: { state: _vm.state },
                      }),
                      _vm.state.sidebarOpen &&
                      !_vm.$wf.isSmDown &&
                      _vm.state.sidebar.Position !== "left"
                        ? _c("app-browse-sidebar", {
                            attrs: { state: _vm.state },
                          })
                        : _vm._e(),
                      _vm.state.inlineIframeUrl &&
                      _vm.state.inlineIframeButton &&
                      _vm.state.inlineIframeButton.IframePosition !== "left"
                        ? _c("app-browse-inline-iframe", {
                            attrs: { state: _vm.state },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "bottom", attrs: { "no-margin": "" } },
                    [
                      _c("app-browse-total-items-result", {
                        attrs: { state: _vm.state },
                      }),
                      _c("w-spacer"),
                      _c("app-browse-selection-totals", {
                        attrs: { state: _vm.state },
                      }),
                      _c("app-browse-totals", { attrs: { state: _vm.state } }),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    {
                      attrs: { "escape-close": "" },
                      model: {
                        value: _vm.state.showSearch,
                        callback: function ($$v) {
                          _vm.$set(_vm.state, "showSearch", $$v)
                        },
                        expression: "state.showSearch",
                      },
                    },
                    [_c("app-filter-modal", { attrs: { state: _vm.state } })],
                    1
                  ),
                  _c(
                    "w-modal",
                    { attrs: { value: _vm.state.customReportsModalOpen } },
                    [
                      _c("app-custom-report-create", {
                        attrs: { "browse-id": _vm.state.browse.ID },
                        on: {
                          close: function ($event) {
                            _vm.state.customReportsModalOpen = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    { attrs: { value: _vm.state.uploadDocumentItem != null } },
                    [
                      _vm.state.uploadDocumentItem
                        ? _c("app-upload-document-modal", {
                            attrs: {
                              "data-source": _vm.state.uploadDocumentItem,
                            },
                            on: {
                              close: function ($event) {
                                return _vm.state.onDocumentUploadClosed()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              )
            : _c(
                "w-row",
                { key: "load", style: { flexGrow: 1, alignItems: "center" } },
                [
                  _c(
                    "w-col",
                    { style: { flexGrow: 1 } },
                    [_c("app-delayed-progress")],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm.state &&
      _vm.state.dataSource.extraFieldSettings &&
      _vm.selectedItems[0]
        ? _c(
            "w-modal",
            { attrs: { value: _vm.state.extraFieldsEditModal } },
            [
              _c("app-edit-extra-fields-modal", {
                attrs: {
                  value: _vm.selectedItems[0].ExtraFields,
                  "name-settings":
                    _vm.state.dataSource.extraFieldSettings.nameSettings,
                },
                on: {
                  close: function ($event) {
                    _vm.state.extraFieldsEditModal = false
                  },
                  update: function ($event) {
                    return _vm.state.updateExtraFields()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.state && _vm.state.dataSource.extraFieldSettings
        ? _c("app-extra-field-quick-edit", {
            attrs: {
              value: _vm.state.extraFieldQuickEditData,
              "get-selected-extra-fields-func": () =>
                _vm.state.getFirstSelectedExtraFields(),
            },
            on: {
              close: function ($event) {
                _vm.state.extraFieldQuickEditData = null
              },
              confirm: _vm.setExtraFieldsQuickEditValue,
            },
          })
        : _vm._e(),
      _vm.state && _vm.state.dataSource.extraFieldSettings
        ? _c("app-extra-field-quick-edit-field-select", {
            attrs: {
              settings: _vm.state.dataSource.extraFieldSettings.nameSettings,
              show: _vm.state.extraFieldQuickEditShowFieldSelect,
            },
            on: {
              close: function ($event) {
                _vm.state.extraFieldQuickEditShowFieldSelect = false
              },
              confirm: function ($event) {
                return _vm.state.quickEditExtraField($event)
              },
            },
          })
        : _vm._e(),
      _vm.state && _vm.state.openedExtraScriptButtonArgsModal != null
        ? _c(
            "w-modal",
            {
              attrs: {
                value: _vm.state.openedExtraScriptButtonArgsModal != null,
              },
            },
            [
              _c("app-script-args-input-modal", {
                attrs: { script: _vm.state.openedExtraScriptButtonArgsModal },
                on: {
                  close: function ($event) {
                    _vm.state.openedExtraScriptButtonArgsModal = null
                  },
                  confirm: function ($event) {
                    return _vm.state.runBrowseScriptWithArgs($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.state && _vm.state.browseToFileModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [_c("app-browse-to-file-modal", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _vm.state && _vm.state.printLabelsModalOpen
        ? _c("app-print-labels-modal", { attrs: { state: _vm.state } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }